module.exports = __webpack_public_path__ + "static/media/signal.a7edae69.png";